// extracted by mini-css-extract-plugin
export default {"textareaGroup":"styles__textareaGroup--TlNg6","formLabel":"styles__formLabel--XNtn9","errorText":"styles__errorText--kLat2 styles__formLabel--XNtn9"};